import React from "react";
import { Grid } from "semantic-ui-react";
import "./style.less";
import { useSelector } from "react-redux";

function RMBuddyProfileBar({ onEditHandler, calendarClickHandler }) {
  const selectedRmBuddy = useSelector(({ rmBuddies }) =>
    rmBuddies.rmBuddiesList
      ? rmBuddies.rmBuddiesList.find(e => e._id === rmBuddies.selectedRmBuddyId)
      : null
  );
  const assignedBlocks = useSelector(({ rmBuddies }) =>
    rmBuddies.buddyBlocksList && selectedRmBuddy
      ? rmBuddies.buddyBlocksList.filter(
          b =>
            selectedRmBuddy.buddy_block_ids.find(e => e === b._id) !== undefined
        )
      : null
  );

  return selectedRmBuddy ? (
    <div className="RMBuddyDashboard-profileBarMain">
      <Grid alignItems="baseline" id="ViewGrid">
        <Grid.Column width={16}>
          <div className="RMBuddyDashboard-profileBar">
            <Grid alignItems="flex-end">
              <Grid.Column width={8}>
                <h4>BUDDY PROFILE</h4>
                <h3>{selectedRmBuddy.name}</h3>
                <div className="RMBuddyDashboard-profileBarLeft">
                  <Grid id="ViewGrid">
                    <Grid.Column width={4}>
                      <p className="RMBuddyDashboard-profileBarNaIcon">
                        {`${selectedRmBuddy.name.charAt(
                          0
                        )}${selectedRmBuddy.name.charAt(1)}`.toUpperCase()}
                      </p>
                    </Grid.Column>
                    <Grid.Column width={9}>
                      <h5>{selectedRmBuddy.name}</h5>
                      <h5>{selectedRmBuddy.phone_num}</h5>
                      <h5>{selectedRmBuddy.email}</h5>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <div className="RMBuddyDashboard-profileBarIcon">
                        <p>
                          <i
                            onClick={onEditHandler}
                            aria-hidden="true"
                            class="pencil icon"
                          ></i>
                        </p>
                        <p>
                          <i
                            onClick={calendarClickHandler}
                            aria-hidden="true"
                            class="calendar alternate outline icon"
                          ></i>
                        </p>
                      </div>
                    </Grid.Column>
                  </Grid>
                </div>
              </Grid.Column>
              <Grid.Column width={8}>
                <div className="RMBuddyDashboard-profileBarRightMain">
                  <h4>
                    ASSIGNED BUDDY BLOCKS{" "}
                    <span>
                      {/* TODO: future
                         <i aria-hidden="true" class="pencil icon"></i>
                        */}
                    </span>
                  </h4>
                  <div className="RMBuddyDashboard-profileBarRight">
                    {assignedBlocks &&
                      assignedBlocks.map(e => (
                        <div className="RMBuddyDashboard-profileBarAddressBlock">
                          <p>{e.properties.name}</p>
                        </div>
                      ))}
                  </div>
                </div>
              </Grid.Column>
            </Grid>
          </div>
        </Grid.Column>
      </Grid>
    </div>
  ) : (
    <h3>Wait....Buddy profile not loaded.</h3>
  );
}

export default RMBuddyProfileBar;
